import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/legal/terms-and-conditions/global'

export const LEGAL_TERMS_AND_CONDITIONS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
